export default __webpack_public_path__ + "static/media/question_16.eca80744.png";